export function formatPrice(
  amount: number,
  currency: string = 'DKK',
  locale: string = 'da-DK'
): string {
  amount = amount / 100; // Convert cents to main currency unit
  return amount.toLocaleString(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
